import React from 'react';
import {Header} from 'semantic-ui-react';

const ImagePlaceholder = ({typeDocument}) => {
  return (
    <div className="invoice-mt">
      <img
        height="300"
        src={`${process.env.PUBLIC_URL}/media/report.png`}
        alt="imagen de reporte"
      />
      <Header as="h3">Buscar por {typeDocument === 'FC' ? 'Factura' : 'Nota de Crédito'}</Header>
    </div>
  );
};

export default ImagePlaceholder;
